/* eslint-disable react-hooks/exhaustive-deps */
import { Path, StoreKey } from "@common/constans";
import { StorageType } from "@common/enum";
import { IParticipate } from "@common/models/Participate";
import { IParticipateRequest } from "@common/models/ParticipateRequest";
import Button from "@components/general/form/Button";
import Icon from "@components/general/Icon";
import { Action, makeParticipate } from "@service/proxy";
import Storage from "@service/Storage";
import Translate from "@service/Translate";
import { FC, useContext, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { ParticipateAction } from "./Action";
import { ParticipateContext } from "./Context";

export const Welcome: FC = () => {
    const { tr } = Translate;
    const { push } = useHistory();
    const [showParticipateLoading, setShowParticipateLoading] = useState<boolean>(false);
    const { pathname, search } = useLocation();
    const query = new URLSearchParams(useLocation().search);
    const { participateDispatch } = useContext(ParticipateContext);

    const onFlightSurveyStartBtnClick = () => {
        setShowParticipateLoading(true);
        const participateRequest: IParticipateRequest = {
            flightNumber: query.get("FNo") || "",
            flightDate: new Date(query.get("FDT") || "").getTime(),
            linkSource: query.get("LS") || "",
        }
        if (query.get("PNR"))
            participateRequest.pnr = query.get("PNR") || "";
        if (query.get("TKT"))
            participateRequest.ticketNumber = query.get("TKT") || "";
        makeParticipate(Action.POST, { data: participateRequest })
            .then((response) => {
                participateDispatch({ type: ParticipateAction.Participate, payload: response.content as IParticipate });
                push(Path.FlightSurvey.Questionnaire);
            })
            .catch((err) => {
                setShowParticipateLoading(false);
            })
        Storage.set(StoreKey.SearchHistory, pathname + search, StorageType.Session);
    }

    return (
        <div className="flight-survey-start flex flex-center column-direction">
            <Icon name="icon-mahan-air-logo" />
            <div className="desc">{tr("flight_survey_start_desc")}</div>
            <Button
                variant="contained"
                color="primary"
                height="40px"
                text={tr("btn_survey_start")}
                loading={showParticipateLoading}
                disabled={showParticipateLoading}
                onClick={onFlightSurveyStartBtnClick}
            />
        </div>
    )
}
